import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

const PAGE_LABELS = {
    '/clinic/dashboard': 'Dashboard',
    '/clinic/orders': 'Orders',
    '/clinic/toxicologyOrders': 'Tox Orders',
    '/clinic/toxicologyAllTests': 'All Tests',
    '/clinic/allResults': 'All Results',
    '/clinic/allSamples': 'All Samples',
    '/clinic/resultImport': 'Result Import',
    '/clinic/result-import-history': 'Import History',
    '/clinic/resultLinks': 'Result Links',
    '/clinic/hl7Messages': 'HL7 Messages',
    '/clinic/facilityCommunications': 'Communications',
    '/clinic/patients': 'Patients',
    '/clinic/patientMedications': 'Medications',
    '/clinic/insurance': 'Insurance',
    '/clinic/patientsDuplicated': 'Duplicate Patients',
    '/clinic/invoices': 'Invoices',
    '/clinic/selfPayment': 'Self Payment',
    '/clinic/insuranceProvider': 'Insurance Providers',
    '/clinic/audit': 'Audit',
    '/clinic/vipPayments': 'VIP Payments',
    '/clinic/company': 'Company',
    '/clinic/facility': 'Facility',
    '/clinic/facilityTestManagement': 'Test Management',
    '/clinic/integrations': 'Integrations',
    '/clinic/physician': 'Physician',
    '/clinic/user': 'User',
    '/clinic/notificationType': 'Notification Types',
    '/clinic/facilityNotificationManagement': 'Facility Notifications',
    '/clinic/superAdminSettings': 'Super Admin Settings',
    '/clinic/configurations': 'Configurations',
    '/clinic/migrationTool': 'Migration Tool',
    '/clinic/legacyViewer': 'Legacy Viewer',
    '/clinic/userInfo': 'User Info',
    '/clinic/maintenance': 'Maintenance',
    '/clinic/inventory': 'Inventory',
    '/clinic/instrument': 'Instruments',
    '/clinic/lab': 'Lab',
    '/clinic/reflexRules': 'Reflex Rules',
    '/clinic/flags': 'Flags',
    '/clinic/labHubRecords': 'Lab Hub Records',
    '/clinic/quantitativeAnalyte': 'Analytes',
    '/clinic/quantitativeTest': 'Quantitative Tests',
    '/clinic/quantitativeTestPanel': 'Test Panels',
    '/clinic/qualitativeTest': 'Qualitative Tests',
    '/clinic/qcRanges': 'QC Ranges',
    '/clinic/qcSamples': 'QC Samples',
    '/clinic/qc_results': 'QC Results',
    '/clinic/qc_reports': 'QC Reports',
    '/clinic/families': 'Families',
    '/clinic/form-builder': 'Form Builder',
    '/clinic/reports/stateReports': 'State Reports',
    '/clinic/reports/dailyReports': 'Daily Reports',
    '/clinic/reports/failedNotificationReports': 'Failed Notifications',
    '/clinic/reports/graphOrderTotals': 'Order Totals',
};

const MAX_HISTORY = 6;
const STORAGE_KEY = 'bluelot_nav_history';

function getLabel(path) {
    if (PAGE_LABELS[path]) return PAGE_LABELS[path];
    const base = '/' + path.split('/').slice(0, 3).join('/').replace(/^\/+/, '');
    return PAGE_LABELS[base] || path.split('/').filter(Boolean).pop() || 'Page';
}

class NavHistory extends Component {
    constructor(props) {
        super(props);
        let history = [];
        try { history = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]'); } catch(e) {}
        this.state = { history };
    }

    componentDidMount() {
        this.recordPath(this.props.location.pathname);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.recordPath(this.props.location.pathname);
        }
    }

    recordPath(pathname) {
        if (pathname === '/clinic/' || pathname === '/clinic') return;
        let history = [...this.state.history];
        // Remove if already exists (move to end)
        history = history.filter(h => h !== pathname);
        history.push(pathname);
        if (history.length > MAX_HISTORY) history = history.slice(-MAX_HISTORY);
        try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(history)); } catch(e) {}
        this.setState({ history });
    }

    goBack = () => {
        const { history: navHistory } = this.state;
        const current = this.props.location.pathname;
        const idx = navHistory.lastIndexOf(current);
        if (idx > 0) {
            this.props.history.push(navHistory[idx - 1]);
        } else {
            this.props.history.goBack();
        }
    };

    render() {
        const { history: navHistory } = this.state;
        const current = this.props.location.pathname;
        if (navHistory.length <= 1 || current === '/clinic/' || current === '/clinic') return null;

        const currentIdx = navHistory.lastIndexOf(current);
        const canGoBack = currentIdx > 0;
        const prevPages = navHistory.slice(0, currentIdx);

        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                padding: '4px 16px',
                background: 'rgba(0,0,0,0.03)',
                borderBottom: '1px solid rgba(0,0,0,0.08)',
                fontSize: '12px',
                minHeight: '30px',
                flexWrap: 'wrap'
            }}>
                <button
                    className="btn btn-sm btn-link p-0"
                    style={{ fontSize: '12px', color: canGoBack ? '#4a6cf7' : '#aaa', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '4px' }}
                    onClick={this.goBack}
                    disabled={!canGoBack}
                    title="Go back"
                >
                    <i className="fa fa-arrow-left"></i> Back
                </button>
                {prevPages.length > 0 && (
                    <>
                        <span style={{ color: '#ccc', margin: '0 4px' }}>|</span>
                        {prevPages.map((path, i) => (
                            <span key={path} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                {i > 0 && <i className="fa fa-chevron-right" style={{ color: '#ccc', fontSize: '10px' }}></i>}
                                <a
                                    href="#"
                                    style={{ color: '#4a6cf7', textDecoration: 'none' }}
                                    onClick={e => { e.preventDefault(); this.props.history.push(path); }}
                                >
                                    {getLabel(path)}
                                </a>
                            </span>
                        ))}
                        <i className="fa fa-chevron-right" style={{ color: '#ccc', fontSize: '10px', margin: '0 2px' }}></i>
                        <span style={{ color: '#555', fontWeight: 600 }}>{getLabel(current)}</span>
                    </>
                )}
            </div>
        );
    }
}

export default withRouter(NavHistory);
